export interface ColumnItem {
  id: string;
  title: string;
  category: string;
  date: string;
  readMin: number;
  views: string;
  excerpt: string;
  body: string[];
}

export const columns: ColumnItem[] = [
  {
    id: "col-01",
    title: "吃瓜的正确姿势：先分清「事实、说法与推测」",
    category: "方法论",
    date: "09-04",
    readMin: 6,
    views: "3.2万",
    excerpt: "很多争议越吵越乱，是因为把三样东西混在了一起：已被证实的、被单方声称的、还有纯属脑补的。看完这篇，你会多一层信息标尺。",
    body: [
      "一条热点刷屏时，第一步不是急着站队，而是把里面的信息按「可信度」拆开。已被原始记录或官方证实的，叫事实；只有某一方发言、尚未被验证的，叫说法；从只言片语里推出的，最多只能算推测。",
      "把这三类信息分开摆出来，你会发现很多冲突其实不在「事实」层面，而在「说法」与「推测」的交错里。谁在描述自己看到的部分，谁又在用推测补全别人的沉默，想清楚这一点，很多争执自然就没有意义了。",
      "我们写时间线时，也会给每个节点标上它属于哪一类。先确认「这件事目前被证实到什么程度」，再谈谁对谁错，才是真正高效的吃瓜方式。",
    ],
  },
  {
    id: "col-02",
    title: "一张时间线是怎么做出来的？编辑部信息核对流程",
    category: "编辑部手记",
    date: "08-30",
    readMin: 8,
    views: "1.8万",
    excerpt: "从海量发言里捞出可靠节点并不轻松。我们公开这套「先溯源、再交叉、后落笔」的整理流程，也接受大家一起来校对补全。",
    body: [
      "第一步是溯源：任何时间点都必须能找到原始出处，无论是首发账号、官方公告还是媒体记录。找不到出处的「据说」，会先被打上「待证实」，不会直接写进时间线正文。",
      "第二步是交叉：同一节点至少要有两路相互独立的信息可以相互印证，我们才会把它标记为「已确认」。如果只有单方说法，就如实注明是哪一方的表述，而不是擅自当作事实。",
      "第三步才是落笔。我们把时间、主体、行为与后续反应按发生顺序排好，并对尚未形成结论的部分标注「发酵中」。整个流程开放校对，如果你发现哪条有误，欢迎留言，我们核实后会第一时间更正。",
    ],
  },
  {
    id: "col-03",
    title: "从爆点到反转：热点事件为何总在「路上变味」",
    category: "吃瓜观察",
    date: "08-25",
    readMin: 7,
    views: "2.6万",
    excerpt: "一条信息在转发中会不断变形，标题越传越短、细节越传越满。看懂传播失真，你就不容易被第一版「爆点」带节奏。",
    body: [
      "信息每被转手一次，都可能发生一次失真。语气被去掉、限定词被省略、背景被忽略，最后留下来的往往是最有冲击力、也最容易被误读的一句话。这就是为什么第一版「爆点」常常和后来的完整事实对不上。",
      "反过来，细节又会在转发里被不断加码。越传越具体的「内部消息」，大多只是为了让故事显得可信而补上的推测，可信度并不会因此变高。",
      "对普通读者来说，最实用的策略是延迟判断：先记下「发生了什么」，暂时不下「谁对谁错」的结论，等几天看更多独立信源。时间会替你把变味的部分筛出去。",
    ],
  },
  {
    id: "col-04",
    title: "理性吃瓜：如何在信息洪流里保住判断力",
    category: "方法论",
    date: "08-20",
    readMin: 5,
    views: "4.1万",
    excerpt: "不急着表态、不急着站队，先让子弹飞一会儿。几个好用的小习惯，帮你把吃瓜从消耗变成一种有收获的信息训练。",
    body: [
      "习惯一：给情绪和结论之间装一道闸。看到让人上头的标题，先停下来问一句「证据在哪」，而不是立刻转发一个情绪。真正扎实的判断，通常不需要靠喊来完成。",
      "习惯二：只看二手结论时，主动回退一步找原始信源。转述会丢信息，原文往往包含被省略的限定与背景，多一步溯源，就能少一次误读。",
      "习惯三：允许事件暂时没有结论。热点不等于真相已定，很多事会随着更多信息反转。与其焦虑地要求立刻站队，不如把吃瓜当成观察社会传播的一次练习。",
    ],
  },
];